import { hidingHeader } from 'hiding-header';
import React from 'react';

var contextDefault = {
    run: function () { },
    pause: function () { },
    reveal: function () { },
    hide: function () { },
};
var Context = React.createContext(contextDefault);
var useRunHidingHeader = function () { return React.useContext(Context).run; };
var usePauseHidingHeader = function () { return React.useContext(Context).pause; };
var useRevealHidingHeader = function () { return React.useContext(Context).reveal; };
var useHideHidingHeader = function () { return React.useContext(Context).hide; };
var HidingHeader = function (_a) {
    var children = _a.children, _b = _a.className, className = _b === void 0 ? 'hidingHeader' : _b, _c = _a.innerClassName, innerClassName = _c === void 0 ? 'hidingHeader-in' : _c;
    var container = React.useRef(null);
    var _d = React.useState(), hidingHeaderCallbacks = _d[0], setHidingHeaderCallbacks = _d[1];
    React.useEffect(function () {
        var callbacks = hidingHeader(container.current);
        setHidingHeaderCallbacks(callbacks);
    }, []);
    return (React.createElement("div", { className: className, ref: container },
        React.createElement("div", { className: innerClassName },
            React.createElement(Context.Provider, { value: {
                    run: (hidingHeaderCallbacks === null || hidingHeaderCallbacks === void 0 ? void 0 : hidingHeaderCallbacks.run) || contextDefault.run,
                    pause: (hidingHeaderCallbacks === null || hidingHeaderCallbacks === void 0 ? void 0 : hidingHeaderCallbacks.pause) || contextDefault.pause,
                    reveal: (hidingHeaderCallbacks === null || hidingHeaderCallbacks === void 0 ? void 0 : hidingHeaderCallbacks.reveal) || contextDefault.reveal,
                    hide: (hidingHeaderCallbacks === null || hidingHeaderCallbacks === void 0 ? void 0 : hidingHeaderCallbacks.hide) || contextDefault.hide,
                } }, children))));
};

export { HidingHeader, useHideHidingHeader, usePauseHidingHeader, useRevealHidingHeader, useRunHidingHeader };
//# sourceMappingURL=index.es.js.map
